export const FLAG_GETTING_TICKET_CORPORATE_CREDITS =
  'FLAG_GETTING_TICKET_CORPORATE_CREDITS';

export const GET_TICKET_CORPORATE_CREDITS = 'GET_TICKET_CORPORATE_CREDITS';

export const CLEAR_TICKET_CORPORATE_CREDITS = 'CLEAR_TICKET_CORPORATE_CREDITS';

export const FLAG_TICKET_CORPORATE_CREDIT_ACTIVITY =
  'FLAG_TICKET_CORPORATE_CREDIT_ACTIVITY';

export const GET_TICKET_CORPORATE_CREDIT = 'GET_TICKET_CORPORATE_CREDIT';

export const CLEAR_TICKET_CORPORATE_CREDIT = 'CLEAR_TICKET_CORPORATE_CREDIT';

export const GET_TICKET_CORPORATE_INVOICES = 'GET_TICKET_CORPORATE_INVOICES';

export const CLEAR_TICKET_CORPORATE_INVOICES =
  'CLEAR_TICKET_CORPORATE_INVOICES';

export const FLAG_GETTING_TICKET_CORPORATE_INVOICES =
  'FLAG_GETTING_TICKET_CORPORATE_INVOICES';

export const GET_TICKET_CORPORATE_CREDIT_MANUAL_VOUCHER_VALUES =
  'GET_TICKET_CORPORATE_CREDIT_MANUAL_VOUCHER_VALUES';

export const CLEAR_TICKET_CORPORATE_CREDIT_MANUAL_VOUCHER_VALUES =
  'CLEAR_TICKET_CORPORATE_CREDIT_MANUAL_VOUCHER_VALUES';
